export enum SocialLinkType {
  Email = "email",
  Facebook = "facebook",
  Instagram = "instagram",
  Linkedin = "linkedin",
  Twitter = "twitter",
}
